export default __webpack_public_path__ + "static/media/d-11.63850c41.png";